export default (function () {
    const navButton = document.getElementsByClassName('nav-drawer__close-overlay')[0];
    const navDrawer = document.getElementsByClassName('nav-drawer')[0];

    navButton.addEventListener('click', _ => {
        navDrawer.classList.remove('nav-drawer--active');
    });
})();